import { ArrowRight, ChevronDown } from 'lucide-react';
import { FAQ } from '../data/faq';
import { CONTACT_EMAIL } from '../lib/site';

export default function FaqSection() {
  return (
    <section id="faq" className="py-24 bg-surface">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <div className="mb-12">
          <span className="text-xs tracking-[0.3em] uppercase text-primary font-semibold mb-4 block">FAQ</span>
          <h2 className="font-serif text-4xl md:text-5xl tracking-wide">Veelgestelde vragen over nieuwbouw in Grobbendonk</h2>
        </div>

        <div className="divide-y divide-secondary/20 border-y border-secondary/20">
          {FAQ.map((item) => (
            <details key={item.question} className="group">
              <summary className="flex cursor-pointer list-none items-center justify-between gap-6 py-5 text-lg font-medium marker:hidden [&::-webkit-details-marker]:hidden">
                <span>{item.question}</span>
                <ChevronDown size={20} className="shrink-0 text-primary transition-transform group-open:rotate-180" aria-hidden="true" />
              </summary>
              <p className="pb-6 pr-10 text-secondary leading-relaxed">{item.answer}</p>
            </details>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-secondary">
            Staat je vraag er niet bij? Mail ons op{' '}
            <a href={`mailto:${CONTACT_EMAIL}`} className="text-primary underline hover:text-text-main transition-colors">{CONTACT_EMAIL}</a>.
          </p>
          <a
            href="#contact"
            className="bg-primary text-white px-8 py-4 text-sm tracking-widest uppercase hover:bg-text-main transition-all flex items-center gap-3 w-fit shrink-0 whitespace-nowrap"
          >
            Vraag informatie aan <ArrowRight size={16} />
          </a>
        </div>
      </div>
    </section>
  );
}
